import { createSlice } from "@reduxjs/toolkit";
import { resetData } from "../app/reducer";

const INITIAL_STATE = {
  currentLocation: null,
  centerPoint: null,
  parcels: [],
  roads: [],
  buildings: [],
  neighbourhoods: [],
  searchPlacesLoading: false,
  places: [],
  nearBy_places: [],
  fetchSuggestionLoading: false,
  suggestions: [],
  activePlace: null,
  serviceName: [],
  closedRoads: [],
};

const mapSlice = createSlice({
  name: "map",
  initialState: INITIAL_STATE,
  reducers: {
    setServiceName: (state, { payload: { placeName } }) => {
      return {
        ...state,
        serviceName: placeName,
      };
    },
    setCurrentLocation: (state, { payload: { location } }) => {
      return {
        ...state,
        currentLocation: location,
      };
    },
    setActivePlace: (state, { payload: { coordinate } }) => {
      return {
        ...state,
        activePlace: coordinate,
      };
    },
    searchByNameStart: (state) => {
      return {
        ...state,
        searchPlacesLoading: true,
      };
    },
    searchByNameSuccess: (
      state,
      { payload: { places, parcels, buildings, roads, neighbourhoods } }
    ) => {
      return {
        ...state,
        searchPlacesLoading: false,
        places,
        parcels,
        buildings,
        roads,
        neighbourhoods,
      };
    },
    searchByNameError: (state) => {
      return {
        ...state,
        searchPlacesLoading: false,
      };
    },
    searchByCategoryStart: (state) => {
      return {
        ...state,
        searchPlacesLoading: true,
      };
    },
    searchByCategorySuccess: (state, { payload: { places } }) => {
      return {
        ...state,
        searchPlacesLoading: false,
        places,
      };
    },
    searchByCategoryError: (state) => {
      return {
        ...state,
        searchPlacesLoading: false,
      };
    },

    searchNearByStart: (state) => {
      return {
        ...state,
        searchPlacesLoading: true,
      };
    },
    searchNearBySuccess: (state, { payload: { nearBy_places } }) => {
      return {
        ...state,
        searchPlacesLoading: false,
        nearBy_places,
      };
    },
    searchNearByError: (state) => {
      return {
        ...state,
        searchPlacesLoading: false,
      };
    },
    searchByAreaStart: (state) => {
      return {
        ...state,
        searchPlacesLoading: true,
      };
    },
    searchByAreaSuccess: (state, { payload: { places, centerPoint } }) => {
      return {
        ...state,
        searchPlacesLoading: false,
        places,
        centerPoint,
      };
    },
    searchByAreaError: (state) => {
      return {
        searchPlacesLoading: false,
        ...state,
      };
    },

    suggestionFetchStart: (state) => {
      return {
        ...state,
        fetchSuggestionLoading: true,
      };
    },
    suggestionFetchSuccess: (state, { payload: { suggestions } }) => {
      return {
        ...state,
        suggestions,
        fetchSuggestionLoading: false,
      };
    },
    suggestionFetchError: (state) => {
      return {
        ...state,
        fetchSuggestionLoading: false,
      };
    },

    closeRoadFetchStart: (state) => {
      return {
        ...state,
      };
    },
    closeRoadFetchSuccess: (state, { payload: { closedRoads } }) => {
      return {
        ...state,
        closedRoads,
      };
    },
    closeRoadFetchError: (state) => {
      return {
        ...state,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetData, (state) => {
      return {
        ...state,
        currentLocation: null,
        centerPoint: null,
        parcels: [],
        roads: [],
        buildings: [],
        searchPlacesLoading: false,
        places: [],
        fetchSuggestionLoading: false,
        suggestions: [],
        roads: [],
        activePlace: null,
        closedRoads: [],
      };
    });
  },
});

export const {
  setServiceName,
  setCurrentLocation,
  setActivePlace,
  searchByNameStart,
  searchByNameSuccess,
  searchByNameError,
  searchByCategoryStart,
  searchByCategorySuccess,
  searchByCategoryError,
  searchNearByStart,
  searchNearBySuccess,
  searchNearByError,
  searchByAreaStart,
  searchByAreaSuccess,
  searchByAreaError,
  suggestionFetchStart,
  suggestionFetchSuccess,
  suggestionFetchError,
  closeRoadFetchError,
  closeRoadFetchSuccess,
  closeRoadFetchStart,
} = mapSlice.actions;

export default mapSlice.reducer;
